<template>
    <div>
        <!--  Change Password Form  -->
        <section class="container-fluid stepsBar">
            <div class="container mt-5">
                <div class="whiteBgContent">
                <h1 class="mb-4">Return Policy</h1>
                <ol type="A" class="mb-4 ml-4 lis">
                    <li>Customers have up to 12 days to return any item.</li>
                    <li>Customers must ship the item directly to the vendor. </li>
                    <li>Customer is responsible for shipping costs.</li>
                    <li>The vendor may charge the Customer a “Restocking” fee no greater than the cost to ship the item back.</li> 
                    <li>If a restocking fee is assessed by the vendor the restocking fee will be deducted directly from the customer's refund. </li>
                    <li>Refunds will be credited back to Customers' credit/debit card upon the vendor’s receipt and acknowledgment of the returned item. </li>
                    <li>After a refund has been processed, expect 7-14 business days to receive the funds.</li>
                </ol>

                <h2 class="mb-3">To qualify for a general return, the item(s): </h2>
                <ul class="mb-4 ml-4 lis">
                    <li>Must be in its original condition </li>
                    <li>Must be free from scratches and/or defects </li>
                    <li>Must not have been installed </li>
                    <li>Must be in the original manufacturer’s box and packaging </li>
                    <li>Must not be missing pieces</li>

                </ul>

                <h2 class="mb-3">FAQ <small>Returns</small></h2>

                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How do I set up a return?</h3>
                    <p>To set up a return, please contact WeVisu support team at <a href="mailto:support@wevisu.com">support@wevisu.com</a></p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How do I send my return?</h3>
                    <p>Once you have made a return request with the support team, you will receive email instructions on how to send your return back to the vendor.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How long do I have to return an item?</h3>
                    <p>Customers have up to 12 days to return any item.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">Who can I contact if I need assistance with my return?</h3>
                    <p>You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What is the status of my refund?</h3>
                    <p>Once we have received confirmation from the vendor that the returned item has been received and qualifies for return, after deducting the restocking fee,  WeVisu will credit back your refund within fourteen (14) business days.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What is the status of my return request?</h3>
                    <p>WeVisu will email regular updates regarding your return request.</p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What if I received the wrong item?</h3>
                    <p>Should you receive the wrong item, please notify the Wevisu Support Team as soon as possible. You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>. You will have twelve (12) days to return the item.  </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">What if I received an incomplete order?</h3>
                    <p>Please notify the Wevisu Support Team no later than two weeks after receiving an incomplete order. You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>. </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">The item I received was defective. How do I get a refund?</h3>
                    <p>Should you receive a defective item, please notify the Wevisu Support Team as soon as possible. You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>. You will have twelve (12) days to return the item.  </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">My purchase was damaged in transit. How do I return it, request a replacement, and/or file a claim? </h3>
                    <p>Should you receive a damaged item, please notify the WeVisu Support Team as soon as possible. You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>. You will have twelve (12) days to return the item.  </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">My purchase was lost in transit; what should I do?</h3>
                    <p>If an item was lost in transit, please review any tracking information and notify the WeVisu Support Team as soon as possible. You may contact support by emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>.</p>
                </div>

                <h2 class="mb-3">Cancellation Policy</h2>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">Can I cancel an order after it was made?</h3>
                    <p>This process varies according to your order type and the stage the order is in. You may cancel your order within 60 minutes after order placement. If it is too late to cancel your order, you may return any unwanted items under our return policy. Please contact the WeVisu support team at <a href="mailto:support@wevisu.com">support@wevisu.com</a> as soon as possible to see how we may further assist you. </p>
                </div>
                <div class="card p-4 bg-light mb-4">
                    <h3 class="font22">How do I cancel an order?</h3>
                    <p>Please contact the WeVisu support team at <a href="mailto:support@wevisu.com">support@wevisu.com</a> as soon as possible.</p>
                </div>
            </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Retrun_policy",
    components: {

    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    },

    created() {

    }
}

</script>
